module.exports = "<ngx-ui-loader></ngx-ui-loader>"